import React from "react";
import { Link } from 'react-router-dom';
import styled, { css } from "styled-components";
import { breakpoints } from '../utils/styles';
import { onAvatarLoadError } from "../utils/misc";
import IconUser from '../assets/svg/nav-icon--user.svg';

const FooterNav = styled.nav`
  background: var(--page-bg);
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  bottom: 0;
  font-size: 0.7rem;
  left: 0;
  line-height: 1.2;
  padding: 0.85rem 0.4rem 0.65rem;
  position: fixed;
  text-align: center;
  width: 100%;
  z-index: 1;

  & > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: ${props => `repeat(${Math.min(props.itemCount, 5)}, 1fr)`};
  }

  ${() => `@media screen and (min-width: ${breakpoints.desktop}px) {
    display: none;
  }`}

  body.theme-market & {
    box-shadow: 0 0 10px rgba(255,255,255,0.25);
  }
  body.theme-platinum & {
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
  }

  body.no-nav & { display: none; }
`;

const FooterNavPic = css`
    display: block;
    margin: 0 auto 0.25rem;

    body.theme-market & { margin-bottom: 0.75rem; }
`;

const FooterNavImage = styled.img`
    ${FooterNavPic}
    height: 1.75rem;
    ${props => props.isAvatar ? 'border-radius: 100%;' : ''}
`;

const FooterNavSvg = styled.div`
    ${FooterNavPic}
    background: var(--text-primary);
    height: 1.75rem;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    width: 1.75rem;
`;

const FooterNavItem = styled.li`
  position: relative;

  & > a {
    color: ${props => props.active ? 'var(--primary);' : 'var(--text-color);'};
  }
  & > a > ${FooterNavSvg} {
    background: ${props => props.active ? 'var(--primary);' : 'var(--text-primary);'};
  }

  ${props => props.hasNotifications ? `
    &:before {
        background: var(--primary);
        border-radius: 12px;
        content: "";
        display: block;
        height: 12px;
        right: 25%;
        position: absolute;
        top: -4px;
        width: 12px;
    }
  ` : ''}

  body.theme-market & {
    font-size: 0.9em;
    text-transform: uppercase;
  }
`;

class FooterMobileNav extends React.Component {
    constructor(props) {
        super(props);
        this.onAuthClick = this.onAuthClick.bind(this);
    }

    onAuthClick(e) {
        e.preventDefault();
        this.props.openAuthPanel();
    }

    isInternalUrl(url) {
        return url && url.startsWith('/');
    }

    renderDynamicMenuItem(item, index) {
        const isInternal = this.isInternalUrl(item.url);
        const active = this.props.path === item.url;

        const LinkComponent = isInternal ? Link : 'a';
        const linkProps = isInternal 
            ? { to: item.url }
            : { href: item.url, target: '_blank', rel: 'noopener noreferrer' };

        return (
            <FooterNavItem key={index} active={active}>
                <LinkComponent {...linkProps}>
                    {item.icons && Object.keys(item.icons).map(concept => (
                        <FooterNavImage src={item.icons[concept][active ? 'active' : 'default']} className={`d-${concept}-only`} alt="" />
                    ))}
                    {item.title}
                </LinkComponent>
            </FooterNavItem>
        );
    }

    render() {
        const { menuItems } = this.props;

        if (!menuItems || menuItems.length === 0) {
            return null;
        }
        
        const itemCount = menuItems.length + 1;

        return <FooterNav itemCount={itemCount}>
            <ul>
                <>
                    {menuItems.map((item, index) => this.renderDynamicMenuItem(item, index))}
                    {this.renderUserLink()}
                </>
            </ul>
        </FooterNav>;
    }

    renderUserLink() {
        const { user } = this.props;
        const currentPath = this.props.path;
        let active, path, onClick;

        if (!user) {
            path = '/usuario';
            active = false;
            onClick = this.onAuthClick;
        } else {
            path = '/usuario';
            active = currentPath === path; //currentPath.indexOf(path) === 0 && currentPath.indexOf('/invitado-especial') === -1;
            onClick = null;
        }

        return <FooterNavItem active={active}><Link to={path} onClick={onClick}>
            {user ? <FooterNavImage src={user.avatar} alt="Foto de perfil" onError={onAvatarLoadError} isAvatar /> : <FooterNavSvg style={{maskImage: `url(${IconUser}`}}></FooterNavSvg>}
            Perfil
        </Link></FooterNavItem>;
    }
}

export default FooterMobileNav;